/**
 *
 * ServiceRequestsManagerMobileGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedMobileGrid from 'containers/AdvancedMobileGrid';

import {
  ACTIVE_REQUESTS,
  MANAGER_REQUESTS,
  REQUESTS_SERVICE_AND_WORK_PRODUCTION,
} from 'domain/Data/Filters/constants';
import { columnType } from 'domain/typeConstants/table';

import { SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID } from './constants';

import {
  addActionButton,
} from '../common/actionButton';
import {
  viewActionItem,
  copyActionItem,
  editActionItem,
  acceptActionItem,
  rejectActionItem,
  completeActionItem,
} from '../common/actionMenu';

import {
  RowComponent, getRowHeight, statusColorLabels,
} from '../common/mobile';

class ServiceRequestsManagerMobileGrid extends React.PureComponent {

  getFilters() {
    const { viewName } = this.props;
    const filters = [REQUESTS_SERVICE_AND_WORK_PRODUCTION];
    if (viewName === 'active') filters.push(ACTIVE_REQUESTS);
    if (viewName === 'manager') filters.push(MANAGER_REQUESTS);
    return filters;
  }


  getDetailRowFields() {
    return [
      {
        name: 'number',
        title: '№',
        type: columnType.NUMERIC,
      },
      {
        name: 'actualCreationDate',
        title: 'Добавлено',
        type: columnType.DATE,
      },
      {
        name: 'companyName',
        getValue: (row) => (row.company ? row.company.name : undefined),
        title: 'Арендатор',
      },
      {
        name: 'statusName',
        getValue: (row) => (row.status ? row.status.name : undefined),
        title: 'Статус',
        type: columnType.LABEL,
        labels: statusColorLabels,
      },
      {
        name: 'serviceName',
        getValue: (row) => (row.service ? row.service.name : undefined),
        title: 'Сервис',
      },
      {
        name: 'whereHappened',
        title: 'Где',
      },
      {
        name: 'whatHappened',
        title: 'Что сделать',
      },
      {
        name: 'assigneeName',
        getValue: (row) => (row.assignee ? row.assignee.name : undefined),
        title: 'Исполнитель',
      },
      {
        name: 'executionTerm',
        title: 'Срок исполнения',
        type: columnType.DATE,
      },
      {
        name: 'executionDate',
        title: 'Исполнение факт',
        type: columnType.DATE,
      },
      {
        name: 'fileName',
        getValue: (row) => (row.file ? row.file.name : undefined),
        title: 'Файл',
      },
      {
        name: 'note',
        title: 'Примечание',
      },
    ];
  }

  getActionButtons() {
    return [addActionButton];
  }

  getActionMenuItems() {
    return [
      viewActionItem, editActionItem, copyActionItem, acceptActionItem, rejectActionItem, completeActionItem,
    ];
  }

  getSorting() {
    return [{ columnId: 'number', columnName: 'number', direction: 'desc' }];
  }

  render() {
    const { onActionExecuting, viewName } = this.props;

    return (
      <AdvancedMobileGrid
        entityName="requests"
        name={SERVICE_REQUESTS_MANAGER_REQUESTS_TABLE_GRID}
        actionButtons={this.getActionButtons()}
        actionMenuItems={this.getActionMenuItems()}
        detailRowFields={this.getDetailRowFields()}
        filters={this.getFilters()}
        getRowHeight={getRowHeight}
        onActionExecuting={onActionExecuting}
        rowComponent={RowComponent}
        sorting={this.getSorting()}
        viewName={viewName}
      />
    );
  }
}

ServiceRequestsManagerMobileGrid.propTypes = {
  onActionExecuting: PropTypes.func,
  viewName: PropTypes.string,
};

export default ServiceRequestsManagerMobileGrid;
